import { UPLOAD_SCORE_CARD } from '../types/scoreCardTypes';
import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  uploadScoreCard,
  uploadScoreCardPending,
  uploadScoreCardFulfilled,
  uploadScoreCardRejected,
} = createAsyncActions(UPLOAD_SCORE_CARD, 'uploadScoreCard');


// WEBPACK FOOTER //
// ./src/features/score-card/actions/uploadScoreCardActions.js